import * as React from 'react';
export const checkSvg = React.forwardRef(function checkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.47 2.233a.875.875 0 0 1 .047 1.236L6.142 13.594a.875.875 0 0 1-1.307-.026L.46 8.443a.875.875 0 0 1 1.33-1.136l3.737 4.376 8.706-9.402a.875.875 0 0 1 1.236-.048Z',
    }),
  );
});
checkSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var check = {
  category: 'icon',
  colorable: true,
  name: 'check',
  svg: checkSvg,
};
